function FeatureMaterialIcon({ size = 16 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.81761 6.50942L9.38534 6.81829C9.49713 6.87914 9.5334 7.01064 9.46634 7.11204C9.44636 7.14219 9.41854 7.16741 9.38534 7.18548L5.24297 9.43895C5.0934 9.52035 4.90657 9.52035 4.757 9.43895L0.614684 7.18548C0.502853 7.12463 0.466587 6.99313 0.533688 6.89173C0.553628 6.86158 0.581445 6.83636 0.614684 6.81829L1.18241 6.50942L4.99999 8.58625L8.81761 6.50942ZM8.81761 4.49683L9.38534 4.8057C9.49713 4.86654 9.5334 4.99805 9.46634 5.09945C9.44636 5.12959 9.41854 5.15482 9.38534 5.17289L4.99999 7.55854L0.614684 5.17289C0.502853 5.11204 0.466587 4.98053 0.533688 4.87913C0.553628 4.84899 0.581445 4.82377 0.614684 4.8057L1.18241 4.49683L4.99999 6.57365L8.81761 4.49683ZM5.24297 0.56102L9.38534 2.81451C9.49713 2.87535 9.5334 3.00686 9.46634 3.10826C9.44636 3.1384 9.41854 3.16362 9.38534 3.1817L4.99999 5.56736L0.614684 3.1817C0.502853 3.12086 0.466587 2.98935 0.533688 2.88795C0.553628 2.85781 0.581445 2.83259 0.614684 2.81451L4.757 0.56102C4.90657 0.47966 5.0934 0.47966 5.24297 0.56102ZM4.99999 1.42759L2.1131 2.99811L4.99999 4.56864L7.88689 2.99811L4.99999 1.42759Z"
        fill="#1D94A3"
      />
    </svg>
  );
}

export default FeatureMaterialIcon;
